const initials = 'denomination/';
export const ADD_NEW_DENOMINATION = `${initials}ADD_NEW_DENOMINATION`;
export const REMOVE_AN_DENOMINATION = `${initials}REMOVE_AN_DENOMINATION`;
export const SET_NEW_DENOMINATION = `${initials}SET_NEW_DENOMINATION`;
export const UPDATE_QUANTITY_DENOMINATION = `${initials}UPDATE_QUANTITY_DENOMINATION`;
export const WIPE_OUT_DENOMINATION = `${initials}WIPE_OUT_DENOMINATION`;
export const SET_COUPON_DATA = `${initials}SET_COUPON_DATA`;
export const COUPOUN_CODE_INPUT = `${initials}COUPOUN_CODE_INPUT`;
export const COUPOUN_STATUS_UPDATE = `${initials}COUPOUN_STATUS_UPDATE`;
export const COUPOUN_APPLIED_RESET = `${initials}COUPOUN_APPLIED_RESET`;
export const COUPOUN_CLEAR = `${initials}COUPOUN_CLEAR`;
